import getAPIPath from '../modules/api-location';

window.getCalendarEventsService = function(teamID, successFn) {
    if (window.location.href.includes("calendar")){
      return $.ajax({
        url: `${getAPIPath}queryapi/calendar/${teamID}`,
        type: 'get',
        success: successFn,
        async: true,
        xhrFields: {
          withCredentials: true,
        },

      });
    }else{
      return $.ajax({
        url: `${getAPIPath}queryapi/view-season-plan/${teamID}`,
        type: 'get',
        success: successFn,
        async: true,
        xhrFields: {
          withCredentials: true,
        },

      });
    }

};

window.doesCalendarExistService = function(teamID, successFn) {
  return $.ajax({
    url: `${getAPIPath}queryapi/calendar-exists/${teamID}`,
    type: 'get',
    success: successFn,
    async: true,
    xhrFields: {
      withCredentials: true,
    },

  });
};



// WEBPACK FOOTER //
// ./library/js/services/calendar.service.js